import { timestamp, uuid } from "@/interfaces";

export enum invoice_statuses {
  draft = "draft",
  sent = "sent",
  paid = "paid",
  void = "void",
}

export interface Invoice {
  id: uuid;
  /** Billed appointment; null for Property Contract period invoices. */
  appointment: uuid | null;
  /** Billed Property Contract (daily_work); null for appointment invoices. */
  daily_work: uuid | null;
  /** Calendar-month period billed by a contract invoice (YYYY-MM-DD), else null. */
  period_start: string | null;
  period_end: string | null;
  vendor: uuid;
  client: uuid;
  invoice_number: number; // int8
  issue_date: timestamp;
  due_date: timestamp;
  amount: number; // float8
  status: invoice_statuses;
  paid_at: timestamp | null;
  created_at: timestamp;
  updated_at: timestamp;
}

export interface InvoiceLineItem {
  id: uuid;
  invoice: uuid;
  particular: string;
  description: string;
  quantity: number; // float8
  unit_price: number; // float8
  total_price: number; // float8
  created_at: timestamp;
  updated_at: timestamp;
}
